<template>
    <v-container>
        <div v-if="showcargando" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%" class="DatosGenerales">
                    <v-card flat class="text-xs-center ma-3" loading="primary">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos del usuario</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn dark v-if="!puedeEditarDatosUsuario" @click="EditarDatosUsuario" icon>
                                <v-icon color>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn dark v-if="puedeEditarDatosUsuario" :loading="guardandoDatosUsuario"
                                @click="GuardarDatosUsuario" icon>
                                <v-icon color>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn dark v-if="puedeEditarDatosUsuario && !guardandoDatosUsuario"
                                @click="puedeEditarDatosUsuario = false;" icon>
                                <v-icon color>mdi-keyboard-return</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formUsuario" v-model="valid" lazy-validation>
                                <vs-list lines="two">
                                    <vs-list-item title="Contraseña:" v-if="!passIsHidden && !puedeEditarDatosUsuario"
                                        :subtitle="this.detalleUsuario.Password">
                                        <div class="space-x-1">
                                            <v-btn @click="passIsHidden = true" icon class="boton-redondo" dark>
                                                <v-icon color>mdi-eye-off-outline</v-icon>
                                            </v-btn>

                                            <v-tooltip top v-if="detalleUsuario.Estatus">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn @click="EnviarPass" icon v-on="on" v-bind="attrs"
                                                        class="boton-redondo" dark>
                                                        <v-icon color>mdi-email</v-icon>

                                                    </v-btn>
                                                </template>
                                                <span>Enviar datos de acceso al usuario</span>
                                            </v-tooltip>
                                        </div>

                                    </vs-list-item>

                                    <vs-list-item title="Contraseña:"
                                        :subtitle="'*'.repeat(this.detalleUsuario.Password?.length)"
                                        v-if="passIsHidden && !puedeEditarDatosUsuario">
                                        <div class="space-x-1">
                                            <v-btn @click="passIsHidden = false" icon class="boton-redondo" dark>
                                                <v-icon color>mdi-eye-outline</v-icon>
                                            </v-btn>

                                            <v-tooltip top v-if="detalleUsuario.Estatus">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn @click="EnviarPass" :loading="enviandoDatosAcceso" icon
                                                        v-on="on" v-bind="attrs" class="boton-redondo" dark>
                                                        <v-icon color>mdi-email</v-icon>

                                                    </v-btn>
                                                </template>
                                                <span>Enviar datos de acceso al usuario</span>
                                            </v-tooltip>


                                        </div>
                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarDatosUsuario" class="wrap-text" title="Correos:"
                                        :subtitle="this.detalleUsuario.Correos + ' '">
                                    </vs-list-item>
                                    <vs-list-item v-if="!puedeEditarDatosUsuario" class="wrap-text"
                                        title="Correo Personal:" :subtitle="this.detalleUsuario.CorreoPersonal + ' '">
                                    </vs-list-item>

                                    <!-- edición -->
                                    <!-- pass -->
                                    <v-text-field v-if="puedeEditarDatosUsuario" @input="CalcularFuerzaPass"
                                        :disabled="guardandoDatosUsuario" @keydown.space.prevent
                                        :rules="[v => (v.length == 0 || v.length >= 8) || 'La contraseña debe tener al menos 8 caracteres']"
                                        v-model="datosTemp.pass" label="Contraseña" outlined type="password"
                                        :maxlength="16" :error-messages="validation.errorPass">
                                    </v-text-field>
                                    <v-progress-linear v-if="puedeEditarDatosUsuario" :color="progressBarColor"
                                        height="15" :value="fuerzaPass">

                                    </v-progress-linear>

                                    <!-- correos -->
                                    <v-combobox v-if="puedeEditarDatosUsuario" class="mt-4" outlined chips
                                        deletable-chips multiple no-data-text="Introduzca un correo válido"
                                        label="Correos" :disabled="guardandoDatosUsuario" @input="HandleSelectCorreo"
                                        @update:search-input="HandleWriteCorreos" :search-input.sync="datosTemp.correo"
                                        v-model="datosTemp.correos" @keydown.enter.prevent="addMailValider2"
                                        :items="datosTemp.correosArr"
                                        :rules="[v => (v.length > 0) || 'Ingrese al menos un correo']"
                                        :error-messages="validation.errorCorreo">
                                    </v-combobox>

                                    <div v-if="detalleUsuario.TipoUsuario == 1">
                                        <vs-list-item v-if="!puedeEditarDatosUsuario" title="Fecha de nacimiento: "
                                            :subtitle="this.detalleUsuario.FechaNacimiento ?? '' + ' '">
                                        </vs-list-item>

                                        <template v-if="puedeEditarDatosUsuario">
                                            <div class="">
                                                <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                                    transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="datosTemp.fechaNacimiento"
                                                            label="Fecha de nacimiento"
                                                            :disabled="guardandoDatosUsuario" readonly v-bind="attrs"
                                                            v-on="on">
                                                            <template v-slot:prepend>
                                                                <v-icon>mdi-calendar</v-icon>
                                                            </template>
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="datosTemp.fechaNacimiento" locale="es-mx"
                                                        :active-picker.sync="activePicker" outlined border="3"
                                                        :max="maxdate" :min="mindate" @change="save"></v-date-picker>
                                                </v-menu>
                                            </div>
                                        </template>


                                        <vs-list-item title="Área:" :subtitle="this.detalleUsuario.Area ?? '' + ' '"
                                            v-if="!puedeEditarDatosUsuario">
                                        </vs-list-item>

                                        <vs-list-item v-if="!puedeEditarDatosUsuario" title="Puesto:"
                                            :rules="[v => !!v || 'Seleccione una opción']"
                                            :subtitle="this.detalleUsuario.Puesto ?? '' + ' '">
                                        </vs-list-item>

                                        <vs-list-item v-if="!puedeEditarDatosUsuario" title="Jefe directo:"
                                            :rules="[v => !!v || 'Seleccione una opción']"
                                            :subtitle="this.detalleUsuario.Jefe + ' '">
                                        </vs-list-item>
                                        <template v-if="detalleUsuario.PercibeNomina == 'Nómina'">
                                            <vs-list-item v-if="!puedeEditarDatosUsuario"
                                                title="Fecha de ingreso al seguro social: "
                                                :subtitle="this.detalleUsuario.FechaIngSS ?? '' + ' '">
                                            </vs-list-item>
                                            <template v-if="puedeEditarDatosUsuario">
                                                <div class="">
                                                    <v-menu ref="menuIngSS" v-model="menuIngSS"
                                                        :close-on-content-click="false" transition="scale-transition"
                                                        offset-y min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="datosTemp.fechaIngSS"
                                                                label="Fecha de ingreso al seguro social "
                                                                :disabled="guardandoDatosUsuario" readonly
                                                                v-bind="attrs" v-on="on" @click="validarFecha">
                                                                <template v-slot:prepend>
                                                                    <v-icon>mdi-calendar</v-icon>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="datosTemp.fechaIngSS" locale="es-mx"
                                                            :active-picker.sync="activePicker" outlined border="3"
                                                            :max="maxdateSS" :min="minDateFhIni"
                                                            @change="save"></v-date-picker>
                                                    </v-menu>
                                                </div>
                                            </template>
                                        </template>

                                        <vs-list-item v-if="!puedeEditarDatosUsuario" title="Extensión:"
                                            :subtitle="this.detalleUsuario.Extension?.toString() ?? '' + ' '">
                                        </vs-list-item>

                                        <vs-list-item v-if="!puedeEditarDatosUsuario" title="Agente:"
                                            :subtitle="this.detalleUsuario.AgenteQuemetrix?.toString() ?? '' + ' '">
                                        </vs-list-item>

                                        <v-autocomplete v-if="puedeEditarDatosUsuario" v-model="datosTemp.area"
                                            label="Área" no-data-text="Sin datos" :disabled="guardandoDatosUsuario"
                                            :rules="rulesArea" item-text="pudireccion" item-value="pudireccion"
                                            :items="datosSelect.areas" outlined>
                                        </v-autocomplete>



                                        <v-autocomplete v-if="puedeEditarDatosUsuario"
                                            :rules="[rulesPuestoUsuario.validaPuesto(datosTemp.area)]"
                                            v-model="datosTemp.puesto"
                                            :disabled="!datosSelect.puestos.length || guardandoDatosUsuario"
                                            item-text="DescripcionPuesto" item-value="puid" no-data-text="Sin datos"
                                            label="Puesto" :items="datosSelect.puestos" outlined>
                                        </v-autocomplete>


                                        <v-autocomplete v-if="puedeEditarDatosUsuario" v-model="datosTemp.jefe"
                                            :disabled="!datosSelect.nombresJefes?.length || guardandoDatosUsuario"
                                            :rules="[v => !!v || 'Seleccione una opción']" item-text="usnom"
                                            item-value="usid" return-object no-data-text="Sin datos"
                                            label="Jefe directo" :items="datosSelect.nombresJefes" outlined>
                                        </v-autocomplete>



                                        <v-text-field v-if="puedeEditarDatosUsuario" outlined
                                            v-model="datosTemp.extension" label="Extensión"
                                            :disabled="guardandoDatosUsuario" type="text" maxlength="4"
                                            :rules="[v => !v?.toString()?.match(/[^0-9]+/g) || 'Este campo sólo acepta caracteres numericos']"
                                            @keypress="validarRegex($event, 'N')">
                                        </v-text-field>


                                        <v-text-field v-if="puedeEditarDatosUsuario" v-model="datosTemp.agente" outlined
                                            :disabled="guardandoDatosUsuario" label="Agente" type="text" maxlength="4"
                                            :rules="[v => !v?.toString()?.match(/[^0-9]+/g) || 'Este campo sólo acepta caracteres numericos']"
                                            @keypress="validarRegex($event, 'N')">
                                        </v-text-field>

                                        <vs-list-item title="Tarificador:"
                                            :subtitle="this.detalleUsuario.Tarificador?.toString() ?? '' + ' '">

                                            <v-btn @click="GenerarTarificador(true)" icon class="boton-redondo" dark
                                                v-if="!this.detalleUsuario.Tarificador">
                                                <v-icon color>mdi-plus</v-icon>
                                            </v-btn>
                                            <div class="space-x-1">
                                                <v-btn @click="GenerarTarificador(true)" icon class="boton-redondo" dark
                                                    v-if="this.detalleUsuario.Tarificador">
                                                    <v-icon style="font-size: 20px;">mdi-reload</v-icon>
                                                </v-btn>
                                                <v-btn @click="GenerarTarificador(false)" icon
                                                    style="background-color: #536dfe; " dark
                                                    v-if="this.detalleUsuario.Tarificador">
                                                    <v-icon style="font-size: 30px;">mdi mdi-alpha-x</v-icon>
                                                </v-btn>
                                            </div>
                                        </vs-list-item>

                                        <vs-list-item title="ACD (Clave de agente):"
                                            :subtitle="this.detalleUsuario.ACD?.toString() ?? '' + ' '">
                                            <v-btn @click="GenerarACD(true, false)" icon v-if="!this.detalleUsuario.ACD"
                                                class="boton-redondo" dark>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            <div class="space-x-1">
                                                <v-btn @click="GenerarACD(true, true)" icon
                                                    v-if="this.detalleUsuario.ACD" class="boton-redondo" dark>
                                                    <v-icon style="font-size: 20px;">mdi-reload</v-icon>
                                                </v-btn>

                                                <v-btn @click="GenerarACD(false)" icon v-if="this.detalleUsuario.ACD"
                                                    class="boton-redondo" dark>
                                                    <v-icon style="font-size: 30px;">mdi-alpha-x</v-icon>
                                                </v-btn>
                                            </div>
                                        </vs-list-item>

                                    </div>

                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                    <!-- residencia -->
                    <v-card flat class="text-xs-center ma-3 DatosGenerales" v-if="detalleUsuario.TipoUsuario == 1">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Lugar de residencia</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-btn dark v-if="!puedeEditarLocalidad" @click="EditarResidencia" icon>
                                <v-icon color>mdi-pencil</v-icon>
                            </v-btn>

                            <v-btn dark v-if="puedeEditarLocalidad" @click="GuardarLocalidad" icon
                                :loading="guardandoLocalidad">
                                <v-icon color>mdi-content-save</v-icon>
                            </v-btn>

                            <v-btn dark v-if="puedeEditarLocalidad" @click="puedeEditarLocalidad = false;" icon>
                                <v-icon color>mdi-keyboard-return</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formLocalidad" v-model="valid" lazy-validation :disabled="guardandoLocalidad">
                                <vs-list>
                                    <vs-list-item v-if="!puedeEditarLocalidad" title="Estado:"
                                        :subtitle="this.detalleUsuario.Estado ?? '' + ' '">

                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarLocalidad" title="Localidad:"
                                        :subtitle="this.detalleUsuario.Localidad ?? '' + ' '">
                                    </vs-list-item>

                                    <!-- inputs -->

                                    <v-autocomplete v-if="puedeEditarLocalidad" v-model="datosTemp.estado"
                                        label="Estado" @input="ObtenerLocalidades" :disabled="guardandoLocalidad"
                                        :rules="[v => !!v || 'Seleccione un estado']" no-data-text="Sin datos"
                                        :items="datosSelect.estados?.map(e => e.Nombre)" outlined>
                                    </v-autocomplete>

                                    <v-autocomplete v-if="puedeEditarLocalidad" v-model="datosTemp.localidad"
                                        label="Localidad" :rules="[v => !!v || 'Seleccione una localidad']"
                                        :disabled="!datosSelect.localidades?.length || guardandoLocalidad"
                                        no-data-text="Sin datos" :items="datosSelect.localidades?.map(l => l.Nombre)"
                                        outlined>
                                    </v-autocomplete>

                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card>

            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%" class="DatosGenerales">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos Generales</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formasegurado" v-model="valid" lazy-validation>
                                <vs-list>
                                    <template v-if="detalleUsuario.TipoUsuario === 1">
                                        <center>
                                            <div>
                                                <div class="circle-container">
                                                    <img v-if="!cargandoFoto"
                                                        :src="fotoPerfil ? fotoPerfil : 'https://www.ausa.com.mx/img/images/perfil.png'"
                                                        alt="prfile_pic">
                                                    <!-- "~/images/perfil.png -->
                                                    <label class="messenger-avatar-btn">
                                                        <span style="font-size: 25px;"
                                                            class="mdi mdi-image-edit"></span>
                                                        <input id="foto-perfil" style="display:none;"
                                                            class="file-upload-input" type="file" name="file"
                                                            accept=".jpg,.png,.jpeg" @change="fotoUpload">
                                                    </label>
                                                    <label class="messenger-avatar-btn" style="left: 0;"
                                                        @click="EliminarFotoPerfil">
                                                        <span style="font-size: 25px;" class="mdi mdi-alpha-x"></span>

                                                    </label>
                                                    <!-- </label> -->
                                                    <span class="loader-foto" v-if="cargandoFoto"></span>
                                                </div>
                                            </div>
                                        </center>
                                    </template>

                                    <vs-list-item title="Nombre:"
                                        :subtitle="this.detalleUsuario.NombreCompleto + ' '"></vs-list-item>
                                    <vs-list-item title="Uslogin:"
                                        :subtitle="this.detalleUsuario.Uslogin"></vs-list-item>
                                    <vs-list-item title="Tipo de usuario: "
                                        :subtitle="this.detalleUsuario.NombreTipoUsuario + ' '"></vs-list-item>


                                    <vs-list-item title="Estatus: ">
                                        <svg v-if="detalleUsuario.Estatus" style="margin-left: auto" width="35"
                                            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 20.5C13.784 20.5 15.4397 19.9504 16.8069 19.0112C17.4108 18.5964 17.6688 17.8062 17.3178 17.1632C16.59 15.8303 15.0902 15 11.9999 15C8.90969 15 7.40997 15.8302 6.68214 17.1632C6.33105 17.8062 6.5891 18.5963 7.19296 19.0111C8.56018 19.9503 10.2159 20.5 12 20.5Z"
                                                :fill="detalleUsuario.colorInactividad" />
                                        </svg>

                                        <!-- <svg v-if="!detalleUsuario.Estatus" width="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> -->
                                        <svg v-if="!detalleUsuario.Estatus" style="margin-left: auto" width="35"
                                            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 20.5C13.784 20.5 15.4397 19.9504 16.8069 19.0112C17.4108 18.5964 17.6688 17.8062 17.3178 17.1632C16.59 15.8303 15.0902 15 11.9999 15C8.90969 15 7.40997 15.8302 6.68214 17.1632C6.33105 17.8062 6.5891 18.5963 7.19296 19.0111C8.56018 19.9503 10.2159 20.5 12 20.5Z"
                                                fill="#c14e4e" />
                                        </svg>
                                    </vs-list-item>
                                    <vs-list-item title="Fecha de alta:"
                                        :subtitle="this.detalleUsuario.FechaAlta ?? '' + ' '"></vs-list-item>
                                    <vs-list-item title="Dió de alta:"
                                        :subtitle="this.detalleUsuario.UsuarioAlta ?? '' + ' '"></vs-list-item>
                                    <vs-list-item title="Fecha de baja:" v-if="detalleUsuario.FechaBaja"
                                        :subtitle="this.detalleUsuario.FechaBaja ?? '' + ' '"></vs-list-item>
                                    <vs-list-item title="Fecha de reactivación:"
                                        v-if="!detalleUsuario.FechaBaja && detalleUsuario.FechaReactivacion"
                                        :subtitle="this.detalleUsuario.FechaReactivacion ?? '' + ' '"></vs-list-item>
                                    <vs-list-item title="Fecha de último acceso:"
                                        :subtitle="this.detalleUsuario.FechaUltimoAcceso + ' '"></vs-list-item>
                                    <vs-list-item title="Fecha de cambio de contraseña:"
                                        :subtitle="this.detalleUsuario.FechaCambioPassword + ' '"></vs-list-item>
                                    <vs-list-item title="Esquema:"
                                        :subtitle="this.detalleUsuario.PercibeNomina ?? '' + ' '"></vs-list-item>
                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>

            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%" class="DatosGenerales">

                    <!-- bloqueos  -->
                    <v-card flat class="text-xs-center ma-3">
                        <!-- <v-card flat class="text-xs-center ma-3" v-if="bloqueosUsuario && bloqueosUsuario?.length"> -->
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Registro de bloqueos e inactividad</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <!-- <v-table style="width:100%" cellspacing="0" align="right"> -->
                            </vs-list>
                            <DataTable url="Sistemas/ObtenerBloqueosUsuario" :columns="columnasBloqueos"
                                :params="parametrosBloqueos" :dom="'rt'" :formatterActions="formatterActionsBl"
                                :rowStyle="style" :order="[]" @apiDT="apBl = $event">
                            </DataTable>
                        </v-card-text>
                    </v-card>

                    <!-- perfil -->
                    <v-card flat class="text-xs-center ma-3 DatosGenerales" v-if="detalleUsuario.TipoUsuario === 1">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos de perfil</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn dark v-if="!puedeEditarPerfil" @click="EditarPerfil" icon>
                                <v-icon color>mdi-pencil</v-icon>
                            </v-btn>

                            <v-btn dark v-if="puedeEditarPerfil" :loading="guardandoPerfil" @click="GuardarPerfil" icon>
                                <v-icon color>mdi-content-save</v-icon>
                            </v-btn>

                            <v-btn dark v-if="puedeEditarPerfil" @click="CancelarEdicionPerfil" icon>
                                <v-icon color>mdi-keyboard-return</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formPerfil" v-model="valid" lazy-validation>
                                <vs-list>
                                    <vs-list-item v-if="!puedeEditarPerfil" title="Perfil:"
                                        :subtitle="detalleUsuario.NombrePerfil + ' '">
                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarPerfil && detalleUsuario.Perfil === 4"
                                        title="Clave Abogado (PRCLAVE):"
                                        :subtitle="detalleUsuario.Prclave ? detalleUsuario.Prclave + ' | ' + detalleUsuario.NombreAbogado : '' + ' '">
                                    </vs-list-item>

                                    <!-- Supervisor Operativo -->
                                    <div
                                        v-if="!puedeEditarPerfil && (detalleUsuario.Perfil === 2 || detalleUsuario.Perfil === 3)">
                                        <vs-list-item title="Gerencia:" :subtitle="detalleUsuario.Gerencia + ' '">
                                        </vs-list-item>

                                        <!-- mostrar sólo cuando es supervisor operativo -->
                                        <vs-list-item v-if="detalleUsuario.Perfil === 2" title="Supervisoría:"
                                            :subtitle="detalleUsuario.Supervisoria + ' '">
                                        </vs-list-item>
                                    </div>

                                    <!-- inputs -->
                                    <v-autocomplete v-if="puedeEditarPerfil" v-model="datosTemp.perfil"
                                        :rules="rulesPerfiles" label="Perfil"
                                        :items="datosSelect.perfiles?.map(p => p.pfdesc)" outlined
                                        no-data-text="Sin datos" @input="SeleccionarPerfil" :disabled="guardandoPerfil"
                                        @keydown.enter.prevent>
                                    </v-autocomplete>


                                    <div
                                        v-if="!puedeEditarPerfil && (detalleUsuario.Perfil === 5 || detalleUsuario.Perfil === 15)">
                                        <vs-list-item title="Tipo de ejecutivo:"
                                            :subtitle="detalleUsuario.TipoEjecutivo ?? '' + ' '">
                                        </vs-list-item>
                                        <vs-list-item title="Cuentas asignadas:"
                                            :subtitle="detalleUsuario.Cuentas ?? '' + ' '">
                                        </vs-list-item>
                                    </div>

                                    <vs-list-item v-if="puedeEditarPerfil" title="">

                                        <!-- datos de ejecutivo -->


                                    </vs-list-item>

                                    <div v-if="puedeEditarPerfil">
                                        <div v-if="mostrarAbogados">
                                            <span style="font-weight: bold;">Clave abogado (PRCLAVE):</span>
                                            <multiselect v-model="datosTemp.abogado" @input="validaProveedor = false"
                                                id="ajax" label="Nombre" track-by="prclave"
                                                placeholder="Clave abogado (PRCLAVE)" open-direction="bottom"
                                                :options="datosSelect.abogados" :searchable="true" :loading="isLoading"
                                                :options-limit="30" :limit="3" :allow-empty="false"
                                                :internal-search="false" deselect-label="Valor Seleccionado"
                                                @search-change="BuscarAbogados">
                                                <template slot="clear" slot-scope="props">
                                                    <div class="multiselect__clear" v-if="datosTemp.abogado"
                                                        @mousedown.prevent.stop="limpiarProveedor(props.search)"></div>
                                                </template>
                                                <span slot="noResult">No hay resultados.</span>
                                            </multiselect>
                                            <div v-if="validaProveedor">
                                                <span class='spanError' style="color:red;font-size:12px">
                                                    Campo
                                                    requerido
                                                </span>
                                                <br />
                                            </div>

                                            <hr>
                                        </div>

                                        <div v-if="mostrarGerencias">
                                            <v-autocomplete v-model="datosTemp.gerencia" @input="HandleSelectGerencia"
                                                label="Gerencia" :rules="[v => !!v || 'Seleccione una gerencia']"
                                                :items="datosSelect.gerencias?.map(g => g.Nombre)" outlined
                                                no-data-text="Sin datos" :disabled="guardandoPerfil">
                                            </v-autocomplete>
                                            <hr>
                                        </div>

                                        <div v-if="mostrarSupervisorias">
                                            <v-autocomplete v-model="datosTemp.supervisoria"
                                                :disabled="datosTemp.gerencia == '' || guardandoPerfil"
                                                label="Supervisoría"
                                                :rules="[v => !!v || 'Seleccione una supervisoría']"
                                                no-data-text="Sin datos"
                                                :items="datosSelect.supervisorias?.map(s => s.Nombre)" outlined>
                                            </v-autocomplete>
                                            <hr>
                                        </div>


                                        <div v-if="mostratTiposEjecutivo">
                                            <v-autocomplete v-model="datosTemp.tipoEjecutivo" label="Tipo de ejecutivo"
                                                :rules="[v => !!v || 'Seleccione un tipo de ejecutivo']"
                                                :items="datosSelect.tiposEjecutivo?.map(t => t.Nombre)" outlined
                                                no-data-text="Sin datos" :disabled="guardandoPerfil">
                                            </v-autocomplete>
                                            <hr>


                                            <v-autocomplete v-model="datosTemp.cuentasAsignadas" chips multiple
                                                clearable deletable-chips label="Cuentas asignadas"
                                                :rules="[v => !!v?.length || 'Seleccione al menos una cuenta']"
                                                no-data-text="Sin datos"
                                                :items="datosSelect.clientes?.map(c => c.Nombre)" outlined
                                                :disabled="guardandoPerfil">
                                            </v-autocomplete>
                                            <hr>
                                        </div>

                                        <div v-if="showClean">
                                            <v-radio-group label="Seleccione una opción" :disabled="guardandoPerfil"
                                                v-if="puedeEditarPerfil && datosTemp.perfil" :rules="rulesradios"
                                                v-model="opcPermisos">
                                                <v-radio label="Limpiar permisos de perfil" :value="1"></v-radio>
                                                <v-radio label="Limpiar todos los permisos del usuario"
                                                    :value="2"></v-radio>
                                                <v-radio label="Combinar permisos de perfiles" :value="3"></v-radio>
                                                <v-radio label="Cambiar perfil sin permisos predefinidos"
                                                    :value="4"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>

                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                    <!-- cliente -->
                    <v-card flat class="text-xs-center ma-3 DatosGenerales">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos del cliente</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn dark v-if="!puedeEditarDatosCliente" @click="EditarDatosCliente" icon>
                                <v-icon color>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn dark v-if="puedeEditarDatosCliente" :loading="guardandoDatosCliente"
                                @click="GuardarDatosCliente" icon>
                                <v-icon color>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn dark v-if="puedeEditarDatosCliente" @click="puedeEditarDatosCliente = false;" icon>
                                <v-icon color>mdi-keyboard-return</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formCliente" v-model="valid" lazy-validation>
                                <vs-list>
                                    <!-- labels -->
                                    <vs-list-item v-if="!puedeEditarDatosCliente" title="Cliente:"
                                        :subtitle="this.detalleUsuario.Cliente ?? '' + ' '">

                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarDatosCliente" title="Flotilla:"
                                        :subtitle="this.detalleUsuario.Flotilla ?? '' + ' '">
                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarDatosCliente" title="Número de agente:"
                                        :subtitle="this.detalleUsuario.CveAgente ? this.detalleUsuario.CveAgente + ' | ' + this.detalleUsuario.Agente : '' + ' '">

                                    </vs-list-item>

                                    <vs-list-item v-if="!puedeEditarDatosCliente" title="Oficina:"
                                        :subtitle="this.detalleUsuario.Oficina ?? '' + ' '">

                                    </vs-list-item>
                                    <!-- inputs -->

                                    <v-autocomplete v-if="puedeEditarDatosCliente" v-model="datosTemp.cliente"
                                        @input="LimpiarClienteForm" label="Cliente" :disabled="guardandoDatosCliente"
                                        no-data-text="Sin datos" :items="datosSelect.clientes?.map(c => c.Nombre)"
                                        outlined>
                                    </v-autocomplete>

                                    <v-autocomplete v-if="puedeEditarDatosCliente" v-model="datosTemp.flotilla"
                                        label="Flotilla" no-data-text="Sin datos"
                                        :disabled="!datosTemp.cliente || !datosSelect.flotillas?.length || guardandoDatosCliente"
                                        :items="datosSelect.flotillas ? datosSelect.flotillas.map(f => f.Nombre) : ['']"
                                        outlined>
                                    </v-autocomplete>

                                    <div v-if="puedeEditarDatosCliente">
                                        <multiselect v-model="datosTemp.agenteCliente"
                                            :disabled="!datosTemp.cliente || datosTemp.cliente === '--Seleccione un cliente--' || guardandoDatosCliente"
                                            @input="validaAgente = false" id="ajax2" label="Nombre" track-by="Clave"
                                            placeholder="Número de agente" open-direction="bottom"
                                            :options="datosSelect.agentes" :searchable="true" :loading="isLoadingA"
                                            :options-limit="30" :limit="3" :allow-empty="true" :internal-search="false"
                                            deselect-label="Remover Valor" @search-change="ObtenerAgentes">
                                            <template slot="clear" slot-scope="props">
                                                <div class="multiselect__clear" v-if="datosTemp.agenteCliente"
                                                    @mousedown.prevent.stop="limpiarUsuarios(props.search)"></div>
                                            </template>
                                            <span slot="noResult">No hay resultados.</span>
                                        </multiselect>
                                        <div v-if="validaUsuario">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Campo
                                                requerido
                                            </span>

                                        </div>
                                        <br />
                                    </div>


                                    <v-autocomplete v-if="puedeEditarDatosCliente" v-model="datosTemp.oficina"
                                        label="Oficina" :items="datosSelect.oficinas?.map(c => c.ofcnombre)"
                                        no-data-text="Sin datos"
                                        :disabled="!datosSelect.oficinas?.length || guardandoDatosCliente" outlined>
                                    </v-autocomplete>




                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card>



            </v-flex>
        </v-layout>


        <!-- radio pills -->
        <template>
            <div>
                <div class="d-flex justify-space-around bg-grey-lighten-4 py-6 px-3 mt-4 border-2 border-indigo-400">
                    <div>
                        <ul class="flex-container wrap">
                            <li class="flex-item"
                                v-if="this.detalleUsuario.TipoUsuario === 1 && this.detalleUsuario.Estatus">
                                <v-btn class="media-text" style="background-color: green; color: white; height: 50px;"
                                    @click="PrepararFirmaElectronica">
                                    PREPARAR FIRMA
                                    ELECTRÓNICA
                                </v-btn>
                            </li>
                            <li class="flex-item"
                                v-if="!this.detalleUsuario.Ivr && this.detalleUsuario.TipoUsuario === 1 && this.detalleUsuario.Estatus">
                                <v-btn class="media-text" style="background-color: green; color: white; height: 50px;"
                                    @click="GenerarIVR">
                                    GENERAR
                                    IVR
                                </v-btn>
                            </li>
                            <li class="flex-item" v-if="this.detalleUsuario.Estatus">
                                <v-btn class="media-text" @click="DarDeBaja" :disabled="disabledbaja"
                                    style="background-color: brown; color: white; height: 50px;">DAR DE BAJA</v-btn>
                            </li>
                            <li class="flex-item" v-if="!this.detalleUsuario.Estatus">
                                <v-btn class="media-text" @click="Reactivar"
                                    style="background-color: green; color: white; height: 50px;">REACTIVAR
                                    USUARIO</v-btn>
                            </li>
                            <li class="flex-item" v-if="this.detalleUsuario.Estatus">
                                <v-btn class="media-text" style="background-color: #FF9933; color: white; height: 50px;"
                                    @click="mostrarBusquedaUsuarios = !mostrarBusquedaUsuarios; datosTemp.usuario = ''; validaUsuario = false; datosSelect.usuariosBusqueda = []">
                                    ASIGNAR PERMISOS DE OTRO USUARIO
                                </v-btn>
                            </li>
                            <li class="flex-item" v-if="this.detalleUsuario.TipoUsuario === 1">
                                <v-btn class="media-text"
                                    style="background-color: #536dfe; color: #FFFFFF; height: 50px;"
                                    @click="() => this.$router.push({ name: 'FormatoUsuario' })">IMPRIMIR
                                    FORMATO</v-btn>
                            </li>
                            <li class="flex-item" v-if="this.detalleUsuario.Estatus">
                                <v-btn class="media-text"
                                    style="background-color: #6E82F0; color: #FFFFFF; height: 50px; "
                                    :loading="enviandoCorreo" @click="EnviarCorreoAExterno">ENVIAR DATOS DE
                                    ACCESO</v-btn>
                            </li>
                        </ul>

                    </div>

                </div>



                <div class="w-1/2 m-auto" v-if="mostrarBusquedaUsuarios">

                    <v-form ref="form">
                        <br />
                        <multiselect v-model="datosTemp.usuario" @input="validaUsuario = false" id="ajax1"
                            label="Nombre" track-by="Login" placeholder="Usuario" open-direction="bottom"
                            :options="datosSelect.usuariosBusqueda" :searchable="true" :loading="isLoadingU"
                            :options-limit="30" :limit="3" :allow-empty="false" :internal-search="false"
                            deselect-label="Valor Seleccionado" @search-change="BuscarUsuario">
                            <template slot="clear" slot-scope="props">
                                <div class="multiselect__clear" v-if="datosTemp.usuario"
                                    @mousedown.prevent.stop="limpiarUsuarios(props.search)"></div>
                            </template>
                            <span slot="noResult">No hay resultados.</span>
                        </multiselect>
                        <div v-if="validaUsuario">
                            <span class='spanError' style="color:red;font-size:12px">
                                Campo
                                requerido
                            </span>
                            <br />
                        </div>

                        <div class="d-flex justify-space-around bg-grey-lighten-4 pa-6 mt-4">
                            <v-btn @click="ClonarPermisos" style="background-color: green; color: white">Guardar</v-btn>
                            <v-btn style="background-color: brown; color: white"
                                @click="CancelarBusquedaUsuario">Cancelar</v-btn>
                        </div>
                    </v-form>
                </div>
            </div>
        </template>

        <template>
            <v-card class="mt-4">
                <v-tabs fixed-tabs v-model="tab" style="background-color: #536dfe; color: white;" align-tabs="center">
                    <v-tab :value="1" @click="showTable()">Editar permisos</v-tab>
                    <v-tab :value="0" @click="showTable()">Agregar permisos</v-tab>
                </v-tabs>

                <v-window v-model="tab">
                    <v-window-item :key="2" :value="0">
                        <div class="w-full p-4">

                            <!-- modulos -->
                            <div style="margin: 30px 0px 70px;">

                                <h4 class="text-center mt-4" style="color: gray">
                                    Editar los permisos del usuario {{
                                        this.detalleUsuario.Uslogin
                                    }}
                                </h4>
                                <hr>
                                <v-row class="mt-4 mb-8">
                                    <span class="m-2" v-for="(m, i) in modulosUsuario" :key="m.NombreModulo"
                                        @click="reloadTableEditarPermisos(m.CveModulo)">
                                        <input :checked="m.CveModulo === -1" type="radio" name="size"
                                            :id="m.NombreModulo" class="pointer">
                                        <label class="etiqueta" :for="m.NombreModulo">
                                            {{ m.NombreModulo }}

                                            <label class="etiqueta2" :for="m.NombreModulo">
                                                {{
                                                    m.PermisosDelModulo
                                                }}
                                            </label>
                                        </label>
                                    </span>
                                </v-row>

                            </div>

                            <div v-if="showTables">
                                <DataTable v-show="mostrarTablaEditarPermisos" :url="urlHistorial" select="multiple"
                                    :dom="'Bfrtip'" @SeleccionTabla="AccionesEditarPermisos"
                                    @input="SetPermisosParaEditar" :columns="columnsEditar"
                                    :params="displayInputsEditar" :formatterActions="formatterActions" :rowStyle="style"
                                    :order="[]" @apiDT="epDT = $event" class="tableFilter">
                                </DataTable>
                            </div>



                            <v-btn class="rounded-full p-4" color="error" :loading="cargandoEliminar"
                                @click="EliminarPermisos" :disabled="!permisosParaEliminar?.length">
                                <v-icon color>mdi-trash-can</v-icon>
                                Eliminar
                            </v-btn>
                        </div>

                    </v-window-item>


                    <v-window-item :key="1" :value="1">
                        <div class="w-full p-4">




                            <v-autocomplete class="w-full md:w-1/2 p-4" style="float: right; padding-left: 5px; "
                                v-model="datosTemp.modulo" label="Módulo" item-text="pedesc" item-value="peclave"
                                return-object no-data-text="Sin datos" @input="reloadTableAgregarPermisos"
                                :items="modulos" outlined>
                            </v-autocomplete>
                            <v-text-field class="w-full md:w-1/2 p-4" style="float: right; padding-left: 5px;"
                                v-model="datosTemp.permiso" label="Permiso"
                                v-on:blur="datosTemp.permiso = datosTemp.permiso != null ? datosTemp.permiso.trim() : null"
                                @input="reloadTableAgregarPermisos" outlined>
                            </v-text-field>
                            <div v-if="showTables">
                                <DataTable v-show="mostrarTablaAgregarPermisos" :url="urlAgregarPermisos"
                                    select="multiple" @input="SetPermisosParaAgregar" :columns="columns"
                                    :params="displayInputs" :dom="'Bfrtip'" @SeleccionTabla="SeleccionarTodo"
                                    :formatterActions="formatterActions" :rowStyle="style" :order="[]"
                                    @apiDT="apDT = $event" class="tableFilter">
                                </DataTable>
                            </div>
                            <v-btn class="rounded-full p-4" color="success" :loading="cargandoAgregar"
                                @click="GuardarPermisos" :disabled="!permisosParaAgregar?.length">
                                <v-icon color>mdi mdi-plus</v-icon>
                                Agregar
                            </v-btn>


                        </div>

                    </v-window-item>


                </v-window>
            </v-card>

            <v-dialog transition="dialog-top-transition" max-width="600" v-model="bajaDialog" persistent>
                <template>
                    <v-card>
                        <v-toolbar color="#536dfe" dark>
                            <v-toolbar-title>Seleccione un nuevo jefe</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-form v-model="validForm" ref="form6">
                                <v-row class="mt-4">
                                    <v-col cols="12" md="12">
                                        <v-autocomplete v-model="jefesAsignacion"
                                            :rules="[v => !!v || 'Seleccione una opción']" item-text="usnom"
                                            item-value="usid" return-object no-data-text="Sin datos"
                                            @keydown.enter.prevent label="Jefe directo"
                                            :items="datosSelect.nombresJefes" outlined>
                                        </v-autocomplete>
                                    </v-col>


                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="guardarAsigJefe()"><span
                                    style='color: white;'>Guardar</span></v-btn>
                            <v-btn color="#FF4081" @click="cancelarAsigJefe()"><span
                                    style='color: white;'>Cancelar</span></v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>

        </template>

    </v-container>
</template>

<script>
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import SistemasService from '@/services/Sistemas/sistemas.service'
import ArchivosService from '@/services/Archivos/Archivos.service'
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import { mapState } from 'vuex';

// [ok]: -No guarda el jefe directo - si lo guarda pero eordino no estaba en ctempleados

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable,
    },

    data() {
        return {
            disabledbaja: false,
            jefesAsignacion: '',
            validForm: true,
            bajaDialog: false,
            showTables: true,
            validation: {
                errorPass: '',
                errorCorreo: ''
            },
            maxdate: null,
            mindate: null,
            maxdateSS: null,
            validaAgente: false,
            isLoadingA: false,
            validaUsuario: false,
            isLoadingU: false,
            validaProveedor: false,
            isLoading: false,
            mostrarTablaEditarPermisos: false,
            fuerzaPass: 0,
            progressBarColor: 'red',
            mostrarTablaAgregarPermisos: false,
            mostrarBusquedaUsuarios: false,
            largo: 50,
            detalleUsuario: {
                Uslogin: ''
            },
            passIsHidden: true,
            showcargando: true,
            bloqueosUsuario: [],
            puedeEditarDatosUsuario: false,
            puedeEditarDatosCliente: false,
            puedeEditarLocalidad: false,
            puedeEditarPerfil: false,
            activePicker: null,
            menu: false,
            menuIngSS: false,
            correos: {
                items: null
            },
            minDateFhIni: null,

            datosTemp: {
                fechaNacimiento: '',
                fechaIngSS: '',
                area: '',
                puesto: '',
                jefe: '',
                estado: '',
                localidad: '',
                correos: [],
                correosValor: [],
                correo: '',
                correosArr: [],
                oficina: '',
                cliente: '',
                flotilla: '',
                usuario: '',    //busqueda
                tipoEjecutivo: '',
                cuentasAsignadas: [],
                gerencia: '',
                supervisoria: '',
                abogado: '',
                pass: '',
                agente: '',
                extension: 0,
                claveCliente: '',
                agenteCliente: null,
                modulo: {
                    peclave: -1,
                    pedesc: 'Todo'
                },
                permiso: ''
            },
            datosSelect: {
                areas: [],
                puestos: [],
                puestosArea: [],
                jefesArea: [],
                nombresJefes: [],
                estados: [],
                localidades: [],
                clientes: [],
                flotillas: [],
                agentes: [],
                oficinas: [],
                usuariosBusqueda: [],
                tiposEjecutivo: [],
                gerencias: [],
                supervisorias: [],
                abogados: []
            },
            fotoPerfil: '',
            valid: true,
            tab: 1,
            urlHistorial: `Sistemas/ObtenerPermisosUsuario`,
            urlBloqueos: '2',
            urlAgregarPermisos: `Sistemas/ObtenerPermisosUsuarioParaAgregar`,
            displayInputs: {
                uslogin: '',
                modulo: null,
                permiso: null
            },
            displayInputsEditar: {
                uslogin: '',
                modulo: null,
            },
            style: 'Pendientes',
            //Tabla bloqueos
            apBl: null,
            columnasBloqueos: [
                { name: 'baSitio', data: 'baSitio', title: "Sitio" },
                { name: 'IdBloqueoAcceso', data: 'IdBloqueoAcceso', title: "Desbloquear", formatter: [this, "formateoDesbloquear"] },
                { name: 'baFechaBloqueo', data: 'baContador', title: "Contador" },
                { name: 'baContador', data: 'baFechaBloqueo', title: "Fecha bloqueo" },
                { name: 'baFechaAcceso', data: 'baFechaAcceso', title: "Último acceso" },
            ],
            formatterActionsBl: [
                { click: [this, "Desbloquear"] },
            ],
            parametrosBloqueos: {
                uslogin: ''
            },
            columns: [
                { name: 'ClavePermiso', data: 'ClavePermiso', title: "#" },
                { name: 'Descripcion', data: 'Descripcion', title: "Descripción" },
            ],
            columnsEditar: [
                { name: 'ClavePermiso', data: 'ClavePermiso', title: "#" },
                { name: 'Descripcion', data: 'Descripcion', title: "Descripción" },
                { name: 'Valor', data: 'Valor', title: "Valor" },
            ],
            headersDin: [],

            formatterActions: [
                // { click: [this, "SeleccionarPermiso"] },
            ],
            apiDT: null,
            permisosParaEliminar: [],
            permisosParaAgregar: [],
            usuarioBusqueda: '',
            rulesradios: [v => !!v || 'Seleccione una opción'],
            rulesCombo: [//v => !!v || 'Campo requerido',
                (v) => !!v || "Seleccione un usuario",
                (v) => {
                    if (v == null) return true;
                    else {
                        if (v?.length < 10) {
                            return "Seleccione un usuario";
                        }
                        else return true;
                    }
                },

            ],
            rulesPerfiles: [
                v => !!v || 'Seleccione un perfil'

            ],

            rulesPuestoUsuario: {
                validaPuesto(area) {
                    return v => {
                        if (area != '') {
                            return (v != '' && v !== null) || "Elija un puesto";
                        } else return true
                    }
                    // return v=> (!!v && area != '') || "Seleccione un puesto";
                }

            },
            rulesArea: [v => {
                if (!v || v === '--Seleccione un área--') {
                    return 'Seleccione un área'
                }
                else return true
            }],
            mostratTiposEjecutivo: false,
            mostratDatosEjecutivo: false,
            mostrarGerencias: false,
            mostrarSupervisorias: false,
            mostrarAbogados: false,
            opcPermisos: 0,  //Valor de Radio buttons
            ageid: 0,    //Clave de agente del cliente
            modulos: [],     //modulos de permisos
            modulosUsuario: [],
            localidades: [],    //todas las localidades
            //Loaders
            cargandoAgregar: false,
            cargandoEliminar: false,
            guardandoPerfil: false,
            guardandoLocalidad: false,
            guardandoDatosUsuario: false,
            guardandoDatosCliente: false,
            overlay: false,
            enviandoCorreo: false,
            enviandoDatosAcceso: false,
            cargandoFoto: false,
            showClean: false,
            permisoSaltarPass: false

        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        menuIngSS(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        async 'datosTemp.area'(val) {
            if (val != null) {
                this.datosTemp.puesto = '';
                await this.ObtenerPuestos(val);
            }
        },
        async 'datosTemp.puesto'(val) {
            if (val == '' || val == null) {
                return
            }
            this.datosSelect.nombresJefes = await SistemasService.ObtenerJefes(this.detalleUsuario.Uslogin, this.datosTemp.area, val);
        },
        required(value) {
            if (value instanceof array && value?.length) {
                return 'required.';
            }
            return 'required.';
        },
        async 'datosTemp.cliente'(nombreCliente) {
            if (!nombreCliente) return;
            if (nombreCliente === '--Seleccione un cliente--') {
                this.datosSelect.flotillas = []
                this.datosTemp.claveCliente = null
                this.datosSelect.oficinas = []
                return
            }
            let clienteTemp = this.datosSelect.clientes.filter(c => c.Nombre === nombreCliente)[0]
            if (!clienteTemp) return
            this.datosTemp.claveCliente = clienteTemp ? clienteTemp.Clave : '';
            this.datosSelect.oficinas = await SistemasService.ObtenerOficinas(clienteTemp.Clave)
            await this.ObtenerFlotillas()

        },
        'datosTemp.agenteCliente'(val) {
            if (!val) {
                this.datosTemp.ageid = null;
                return;
            }
            let agenteTemp = val.Nombre?.split("|")[0]?.trim();

            this.datosTemp.ageid = agenteTemp;
        },
        'datosTemp.agente'(text) {
            if (!text?.toString()?.match(/[^0-9]+/g)) return;
            this.datosTemp.agente = text?.toString()?.match(/[0-9]+/g) ?? ''
        },
        'datosTemp.extension'(text) {
            if (!text?.toString()?.match(/[^0-9]+/g)) return;
            this.datosTemp.extension = text?.toString()?.match(/[0-9]+/g) ?? ''
        },
        puedeEditarDatosUsuario(newVal) {
            if (!newVal) {
                this.datosTemp.fechaIngSS = null;
            }
        }



    },
    async mounted() {
        var yyyy = new Date().getFullYear();
        var min = (yyyy - 100) + '-01-01';
        var max = (yyyy - 16) + '-12-31';

        this.maxdate = max;
        this.mindate = min;

        //maximo para fecha de ingreso al seguro social
        var maxSS = (yyyy) + '-12-31';
        this.maxdateSS = maxSS;


        await this.ObtenerDetalleUsuario()
        await this.reloadTableBloqueos();
        await this.reloadTableEditarPermisos(-1, true);
        this.tab = 0;
        await this.reloadTableAgregarPermisos();

        this.showcargando = false;

        await this.ObtenerFotoPerfil();

        this.ObtenerModulos();
        await this.ObtenerModulosUsuario();

        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '170').then(response => {
            if (response.data.length > 0) {
                this.permisoSaltarPass = true;
            }
        });


    },
    methods: {
        async BuscarUsuario(val) {
            if (!val) return;
            if (val?.trim().length < 3) {
                this.datosSelect.usuariosBusqueda = []
                return;
            }
            this.datosSelect.usuariosBusqueda = await SistemasService.BuscarUsuario(val, true, 4)
        },

        async ClonarPermisos() {
            if (this.datosTemp.usuario == '') {
                this.validaUsuario = true;
                return;
            }
            if (!(this.$refs.form.validate() === true)) return;
            if (!this.datosTemp.usuario || this.datosTemp.usuario == '') return;
            let uslogin = MetodosGenerales.ObtenerUserName()
            let usOrigen = this.datosTemp.usuario.Nombre.split('|')[0]
            usOrigen = usOrigen.trim();
            this.showcargando = true
            let res = await SistemasService.ClonarPermisos(uslogin, usOrigen, this.detalleUsuario.Uslogin);

            this.CancelarBusquedaUsuario();
            this.showcargando = false
            await this.ObtenerModulosUsuario();

            await this.reloadTableEditarPermisos(-1, true);
            await this.reloadTableAgregarPermisos();

            this.Notifica('success',
                'Permisos asignados',
                '',
                false);

        },
        limpiarUsuarios() {
            this.datosTemp.usuario = "";
            this.datosSelect.usuariosBusqueda = [];
        },
        limpiarProveedor() {
            this.datosTemp.abogado = "";
            this.datosSelect.abogados = [];
        },
        HandleSelectCorreo() {
            const regexCorreo = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            this.datosTemp.correosArr = [];
            this.datosTemp.correos = this.datosTemp.correos.map(c => c?.trim())
            this.datosTemp.correos = [...new Set(this.datosTemp.correos)];
            this.datosTemp.correos = this.datosTemp.correos.filter(c => c.match(regexCorreo))
        },
        async reloadTableAgregarPermisos() {
            if (this.datosTemp.permiso != '' && this.datosTemp.permiso != null) {
                this.displayInputs.permiso = this.datosTemp.permiso.trim();
            }
            else {
                this.displayInputs.permiso = null;
            }
            if (this.datosTemp.modulo != '' && this.datosTemp.modulo != null) {
                this.displayInputs.modulo = this.datosTemp.modulo.peclave;
            }
            else {
                this.displayInputs.modulo = -1;
            }


            this.displayInputs.uslogin = this.detalleUsuario.Uslogin

            if (this.apDT != null) {
                this.apDT.ajax.reload(null, false);
                this.apDT.columns.adjust().responsive.recalc();
            }
            this.mostrarTablaAgregarPermisos = true;
        },
        async reloadTableEditarPermisos(modulo = -1, force = false) {
            if (this.displayInputsEditar.modulo === modulo && !force) return;
            this.displayInputsEditar.uslogin = this.detalleUsuario.Uslogin
            this.displayInputsEditar.modulo = modulo

            if (this.epDT != null) {
                this.epDT.ajax.reload(null, false);
                this.epDT.columns.adjust().responsive.recalc();
            }
            this.mostrarTablaEditarPermisos = true;
        },
        async reloadTableBloqueos() {
            this.parametrosBloqueos.uslogin = this.detalleUsuario.Uslogin


            if (this.apBl != null) {
                this.apBl.ajax.reload(null, false);
                this.apBl.columns.adjust().responsive.recalc();
            }
        },
        async handleElegirModuloEditar(nombreModulo) {
            nombreModulo = nombreModulo?.replace(/\([^)]*\)\s*/g, '')?.trim();
            let moduloTemp = this.modulosUsuario.filter(m => m.NombreModulo === nombreModulo)[0]
            if (moduloTemp) await this.reloadTableEditarPermisos(moduloTemp.CveModulo)
        },
        SetPermisosParaEditar(permiso) {
            this.permisosParaEliminar = permiso
        },
        SetPermisosParaAgregar(permisos) {
            this.permisosParaAgregar = permisos
        },
        async fotoUpload() {
            const input = document.getElementById("foto-perfil")
            if (!input.files[0]) return;
            this.cargandoFoto = true
            let res = await SistemasService.SubirFotoPerfil(
                this.detalleUsuario.Uslogin,
                MetodosGenerales.ObtenerUserName(),
                input.files[0],
                this.detalleUsuario.FotoUsuario)

                .catch((res) => {

                    this.cargandoFoto = false

                })

            if (res) {
                await this.ObtenerDetalleUsuario();
                await this.ObtenerFotoPerfil();
            }
            this.cargandoFoto = false
        },
        CalcularFuerzaPass(pass) {
            this.validation.errorPass = '';
            var regex = new Array();
            regex.push("[A-Z]"); //Uppercase Alphabet.
            regex.push("[a-z]"); //Lowercase Alphabet.
            regex.push("[0-9]"); //Digit.
            regex.push("[$@$!%*#?&-.;/]");
            // regex.push("[#$%&()?_!.*\\/+:-,@@]"); //Special Character.

            var puntuacion = 0;

            for (var i = 0; i < regex?.length; i++) {
                if (new RegExp(regex[i]).test(pass)) {
                    puntuacion += 2;
                }
            }
            puntuacion = puntuacion + (pass?.length / 2)

            let max = 16


            //MAXIMO 16 CARACTERES    
            puntuacion = puntuacion * 100 / max

            if (puntuacion < 50) this.progressBarColor = 'red'
            else if (puntuacion >= 50 && puntuacion <= 69) this.progressBarColor = 'amber'
            else if (puntuacion >= 70) this.progressBarColor = 'green'
            this.fuerzaPass = puntuacion

        },
        async ObtenerFotoPerfil() {
            this.fotoPerfil = null
            if (!this.detalleUsuario.FotoUsuario) return
            let res = await SistemasService.ObtenerFotoPerfil(this.detalleUsuario.FotoUsuario, this.detalleUsuario.Uslogin)
            this.fotoPerfil = res.watch
        },
        async ObtenerDetalleUsuario() {
            let datosUser = await MetodosGenerales.obtenerSessionReporte('DetalleUsuarioBusqueda');

            await SistemasService.ObtenerDetalleUsuario(datosUser.Login).then((res) => {
                this.detalleUsuario = res

                this.detalleUsuario.Correos = this.detalleUsuario.Correos?.replace(/;/g, "; ")
                this.detalleUsuario.colorInactividad = this.detalleUsuario.Inactividad ? '#ddad46' : '#318c58'
            })
        },
        async GenerarTarificador(action) {
            SistemasService.GenerarTarificador(this.detalleUsuario.Uslogin, this.detalleUsuario.ACD, action).then((res) => {
                this.detalleUsuario.Tarificador = res
            })
        },
        async GenerarACD(action, update) {
            let tarificador = update ? "" : this.detalleUsuario.Tarificador
            await SistemasService.GenerarACD(this.detalleUsuario.Uslogin, tarificador, action).then((res) => {
                this.detalleUsuario.ACD = res
            })
        },
        async EnviarPass() {
            this.enviandoDatosAcceso = true;
            await SistemasService.EnviarPasswordXCorreo(
                this.detalleUsuario.Uslogin,
                this.detalleUsuario.Correos).catch((res) => {
                    this.Notifica('warning', 'Algo salió mal', 'Sugerimos recargar la página; si el problema persiste contacte al equipo de desarrollo.')
                    this.enviandoDatosAcceso = false

                })
            this.enviandoDatosAcceso = false
            this.Notifica('success', 'Correo enviado', 'Los datos de acceso han sido enviados al usuario.')
        },
        async ObtenerBloqueos() {
            await SistemasService.ObtenerBloqueosUsuario(this.detalleUsuario.Uslogin)
                .then((res) => {
                    this.bloqueosUsuario = res
                })
                .catch((e) => console.log(e))
        },
        async Desbloquear(params, item, fila) {
            const res = await SistemasService.DesbloquearUsuario(this.detalleUsuario.Uslogin, item.IdBloqueoAcceso)
                .then(async (res) => {
                    this.Notifica('success', 'Desbloqueo con éxito', '', true)
                    await this.reloadTableBloqueos();
                    this.ObtenerDetalleUsuario();
                })
                .catch((e) => console.log(e))
        },
        save(date) {
            this.$refs.menu.save(date)
            this.$refs.menuIngSS.save(date)
        },
        async EditarDatosUsuario() {
            await this.ObtenerAreas();
            this.puedeEditarDatosUsuario = true;
            this.validation.errorPass = '';
            this.validation.errorCorreo = '';
            this.datosTemp.pass = '';
            this.fuerzaPass = 0;
            this.progressBarColor = 'red';
            if (this.detalleUsuario.FechaNacimiento) {
                let arr = this.detalleUsuario.FechaNacimiento.split('/');
                this.datosTemp.fechaNacimiento = arr[2] + '-' + arr[1] + '-' + arr[0];
            }

            if (this.detalleUsuario.FechaIngSS) {
                let arr = this.detalleUsuario.FechaIngSS.split('/');
                this.datosTemp.fechaIngSS = arr[2] + '-' + arr[1] + '-' + arr[0];
            }
            //Datos
            if (this.detalleUsuario.Correos) this.datosTemp.correos = this.detalleUsuario.Correos?.split(";") ?? [];
            if (this.detalleUsuario.TipoUsuario == 1) {
                this.datosTemp.area = this.detalleUsuario.Area;

                this.datosTemp.jefe = { usnom: this.detalleUsuario.Jefe, usid: this.detalleUsuario.nombreJefe };
                this.datosTemp.extension = this.detalleUsuario.Extension;
                this.datosTemp.agente = this.detalleUsuario.AgenteQuemetrix;

                setTimeout(() => {
                    this.datosTemp.puesto = this.detalleUsuario.CvePuesto;
                }, 1000);
            }



        },
        async ObtenerPuestos(val) {

            this.datosSelect.puestos = await SistemasService.ObtenerPuestos(val);

        },
        async ObtenerAreas() {
            this.datosSelect.areas = await SistemasService.ObtenerAreas();
            this.datosSelect.areas.unshift('--Seleccione un área--');
        },
        async VerificarContraseñaNueva() {
            let respuesta = await SistemasService.VerificarContrasenaFirma(this.detalleUsuario.Uslogin, this.datosTemp.pass);

            if (respuesta) {
                this.validation.errorPass = 'La contraseña ingresada es igual a la firma electrónica, favor de ingresar otra contraseña';

                return 1;
            }
            let respuesta2 = await SistemasService.VerificarCoincidenciasContrasenas(this.detalleUsuario.Uslogin, this.detalleUsuario.Password, this.datosTemp.pass);

            if (respuesta2) {
                this.validation.errorPass = 'La nueva contraseña es similar a la anterior y/o el usuario no puede formar parte de la nueva contraseña, favor de verificar';

                return 1;
            }

            let respuesta3 = await SistemasService.VerificarContenidoContrasena(this.detalleUsuario.Uslogin, this.datosTemp.pass);

            if (respuesta3) {
                this.validation.errorPass = 'La nueva contraseña no puede contener tu nombre, apellidos o fecha de nacimiento';

                return 1;
            }

            let respuesta4 = await SistemasService.VerificarHistorialContrasena(this.detalleUsuario.Uslogin, this.datosTemp.pass);

            if (respuesta4) {
                this.validation.errorPass = 'La nueva contraseña ya fue utilizada anteriormente';

                return 1;
            }



            return 0;
        },
        async showTable() {
            this.datosTemp.permiso = '';
            this.datosTemp.modulo.peclave = -1;
            this.datosTemp.modulo.pedesc = 'Todo';

            this.showTables = false;
            setTimeout(async () => {
                this.showTables = true;
                await this.reloadTableAgregarPermisos();
            }, 200);
        },
        async VerificarContraseñaNuevaSinval() {

            var pcEspeciales = /[#$%&()?_!.*\\/+:,@@]/;
            var pMinisuculas = /[a-z]/;
            var pMayusculas = /[A-Z]/;
            var pNumeros = /[0-9]/;

            if (!pNumeros.test(this.datosTemp.pass)) {
                this.validation.errorPass = 'La contraseña no contiene al menos un número';
                return 1;
            }

            if (!pMinisuculas.test(this.datosTemp.pass)) {
                this.validation.errorPass = 'La contraseña no contiene al menos una minúscula';
                return 1;
            }

            if (!pMayusculas.test(this.datosTemp.pass)) {
                this.validation.errorPass = 'La contraseña no contiene al menos una mayúscula';
                return 1;
            }

            if (!pcEspeciales.test(this.datosTemp.pass)) {
                this.validation.errorPass = 'La contraseña no contiene al menos un caracter especial';
                return 1;
            }

            const regex = /[\\,<>\-\^"'\=ñÑ{};]/;
            if (regex.test(this.datosTemp.pass)) {
                this.validation.errorPass = 'La nueva contraseña contiene carácteres no válidos, favor de verificarlo.';
                return 1;
            }


            if (this.fuerzaPass < 70) {
                this.validation.errorPass = 'El nivel mínimo de seguridad es de 70%';
                return 1;
            }
            return 0;
        },
        async EvaluarInvalidos(cadena) {
            var RegExpCharEspecial = /[\,\<\>\-\^\"\'\=\ñÑ\{\}\;]/;
            var resultado = cadena.match(RegExpCharEspecial);
            if (resultado != null) {
                return true;
            }
            else {
                return false;
            }
        },
        async GuardarDatosUsuario() {
            if (!(this.$refs.formUsuario.validate() === true)) return

            if (this.datosTemp.pass != '') {

                let verifica1 = await this.VerificarContraseñaNuevaSinval();
                if (verifica1 > 0) {
                    this.guardandoDatosUsuario = false;
                    return;
                }
            }
            if (this.datosTemp.pass != '' && !this.permisoSaltarPass) {  //si quiere cambiar la contraseña y no tiene el permiso de saltar validaciones

                this.guardandoDatosUsuario = true;
                let verifica = await this.VerificarContraseñaNueva();
                if (verifica > 0) {
                    this.guardandoDatosUsuario = false;
                    return;
                }
            }


            const regexCorreo = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;

            if (this.datosTemp.correos) this.datosTemp.correos = this.datosTemp.correos.filter((c) => c.trim().match(regexCorreo))


            this.guardandoDatosUsuario = true

            //Fecha de nacimiento
            let fechaNacimiento = this.datosTemp.fechaNacimiento
            fechaNacimiento += " 00:00:00.000"

            //Fecha de ingreso al seguro social
            let fechaIngSS = this.datosTemp.fechaIngSS ? this.datosTemp.fechaIngSS : null;


            let puestoTemp = this.datosSelect.puestos.filter(p => p.DescripcionPuesto === this.datosTemp.puesto && p.pudireccion === this.datosTemp.area)[0]
            //jefeusid
            let jefeTemp = this.datosTemp.jefe;


            let correosTemp = this.datosTemp.correos?.join(";") ?? '';
            let respuesta = await SistemasService.validaCorreos(this.detalleUsuario.Uslogin, correosTemp);

            if (respuesta.error) {
                var correosEnUso = [];
                var mensaje = 'Estos correos ya estan en uso por otros usuarios ¿Desea agregarlos de todos modos?';

                mensaje += "<p></p><div class='col-md-12 col-md-offset-3 text-left'>";

                respuesta.msg.forEach((c) => {
                    correosEnUso.push("(" + c.split(": ")[0] + ")" + c.split(": ")[1]);
                    mensaje += "<div><span class='bg-danger circle sq-16 icon icon-warning'></span> &nbsp;<b>-" + c + "</b></div>";
                });
                mensaje += "</div><div><p>&nbsp</p></div>";


                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    html: mensaje,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.guardaInfo(correosTemp, puestoTemp, fechaNacimiento, jefeTemp, fechaIngSS);
                    }
                    else {
                        this.guardandoDatosUsuario = false;
                    }
                });


            }
            else {
                this.guardaInfo(correosTemp, puestoTemp, fechaNacimiento, jefeTemp, fechaIngSS);
            }


        },
        async guardaInfo(correosTemp, puestoTemp, fechaNacimiento, jefeTemp, fechaIngSS) {

            let response = await SistemasService.ActualizarDatosUsuario(
                this.detalleUsuario.Uslogin,
                this.detalleUsuario.TipoUsuario,
                correosTemp ?? '',
                this.detalleUsuario.Password,    //Pass vieja
                this.datosTemp.pass,    //Pass nueva
                this.datosTemp.puesto,
                fechaNacimiento,
                this.datosTemp.extension,   //uext - extension
                this.datosTemp.agente,   //usagentlgin - agente
                jefeTemp?.usid,
                fechaIngSS //Ingreso al seguro social
            )
                .catch((res) => {
                    this.Notifica('warning', 'Algo salió mal', 'Sugerimos recargar la página; si el problema persiste contacte al equipo de desarrollo.')
                    this.guardandoDatosUsuario = false
                })

            if (response) {
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Datos de usuario actualizados',
                    // text: 'Datos de usuario actualizados',
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                    timer: 3000
                })

                this.ObtenerDetalleUsuario();
            }

            this.guardandoDatosUsuario = false
            this.puedeEditarDatosUsuario = false

        },
        async GuardarDatosCliente() {
            this.guardandoDatosCliente = true;
            // let nombreAgente = this.datosTemp.agenteCliente?.split("|")[1]?.trim()??'';
            let clienteTemp = this.datosSelect.clientes.filter(c => c.Nombre === this.datosTemp?.cliente)[0]
            let oficinaTemp = this.datosSelect.oficinas.filter(c => c.ofcnombre === this.datosTemp?.oficina ?? "")[0]

            let flotillaTemp = this.datosSelect.flotillas?.filter(f => f.Nombre === this.datosTemp?.flotilla ?? "")[0]

            await SistemasService.ActualizarDatosCliente(
                this.detalleUsuario.Uslogin,
                clienteTemp ? clienteTemp.Clave : null,
                flotillaTemp ? flotillaTemp.Clave : null,   //gfclave, flotilla
                this.datosTemp.ageid,   //ageid, agente
                oficinaTemp?.ofcid ?? null   //oepclave
            ).then((response) => {
                if (response) {
                    this.Notifica('success', 'Datos del cliente actualizados', '')

                    this.ObtenerDetalleUsuario();
                    this.guardandoDatosCliente = false;
                }
            })
                .catch((e) => {
                    this.Notifica('warning', 'Algo salió mal', e)
                })
            this.guardandoDatosCliente = false;
            this.puedeEditarDatosCliente = false;
        },
        async ObtenerClientes() {
            this.datosSelect.clientes = await SistemasService.ObtenerClientes()
            this.datosSelect.clientes.unshift({
                Clave: '',
                Nombre: '--Seleccione un cliente--'

            })

        },
        async EditarDatosCliente() {
            this.puedeEditarDatosCliente = true;
            await this.ObtenerClientes();
            this.datosTemp.flotilla = this.detalleUsuario.Flotilla;
            this.datosTemp.cliente = this.detalleUsuario.Cliente;
            this.datosTemp.oficina = this.detalleUsuario.Oficina;

            this.datosTemp.agenteCliente = [];

            if (this.detalleUsuario.CveAgente == "null" || this.detalleUsuario.CveAgente == null) {

                this.datosTemp.agenteCliente = null;

            }
            else {
                this.datosSelect.agentes.push(this.detalleUsuario.CveAgente ? { Clave: this.detalleUsuario.CveAgente, Nombre: this.detalleUsuario.Agente } : { Clave: '', Nombre: '' })
                this.datosTemp.agenteCliente = { Clave: this.detalleUsuario.CveAgente, Nombre: this.detalleUsuario.CveAgente + ' | ' + this.detalleUsuario.Agente } //this.detalleUsuario.CveAgente ? this.detalleUsuario.CveAgente + ' | ' + this.detalleUsuario.Agente : ''

            }

        },
        async EditarPerfil() {
            this.validaProveedor = false;
            await this.ObtenerPerfiles();
            await this.ObtenerTiposEjecutivo();
            await this.ObtenerClientes();

            //Mostrar campos de abogado
            if (this.detalleUsuario.Perfil === 4) {
                this.mostrarAbogados = true;
                //this.datosTemp.abogado = this.detalleUsuario.Prclave ? this.detalleUsuario.Prclave + ' | ' + this.detalleUsuario.NombreAbogado : ''
                this.datosTemp.abogado = { Nombre: this.detalleUsuario.Prclave + ' | ' + this.detalleUsuario.NombreAbogado, prclave: this.detalleUsuario.Prclave };
            }

            //Mostrar campos de ejecutivo
            if (this.detalleUsuario.Perfil === 5 || this.detalleUsuario.Perfil === 15) {
                this.mostratTiposEjecutivo = true
                this.datosTemp.tipoEjecutivo = this.detalleUsuario.TipoEjecutivo
                this.datosTemp.cuentasAsignadas = this.detalleUsuario.Cuentas?.length ? this.detalleUsuario.Cuentas.split("; ") : []
            }

            this.datosTemp.perfil = this.detalleUsuario.NombrePerfil

            this.mostrarGerencias = this.detalleUsuario.Perfil === 2 || this.detalleUsuario.Perfil === 3
            this.mostrarSupervisorias = this.detalleUsuario.Perfil === 2

            if (this.mostrarGerencias) {
                if (!this.datosSelect.gerencias?.length) await this.ObtenerGerencias()
                this.datosTemp.gerencia = this.detalleUsuario.Gerencia
            }

            if (this.mostrarSupervisorias) {
                const gerenciaTemp = this.datosSelect.gerencias.filter(g => g.Nombre === this.detalleUsuario.Gerencia)[0]
                await this.ObtenerSupervisorias(gerenciaTemp.Clave)
                this.datosTemp.supervisoria = this.detalleUsuario.Supervisoria
            }

            this.puedeEditarPerfil = true;
            this.showClean = false;

        },
        LimpiarPerfilForm() {
            this.datosTemp.abogado = ''
            this.datosTemp.tipoEjecutivo = ''
            this.datosTemp.cuentasAsignadas = ''
            this.datosTemp.gerencia = ''
            this.datosTemp.supervisoria = ''
        },
        LimpiarClienteForm() {
            this.datosTemp.flotilla = ''
            this.datosTemp.agenteCliente = null
            this.datosTemp.oficina = ''
        },
        Notifica(icon, title, text, timer = true) {
            this.$swal({
                position: 'center',
                icon: icon,
                title: title,
                text: text,
                showConfirmButton: true,
                confirmButtonColor: '#536DFE',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false,
                timer: timer ? 3000 : false
            })
        },
        async ObtenerEstados() {
            this.datosSelect.estados = await SistemasService.ObtenerEstados()
            this.datosSelect.estados.unshift({
                Clave: null,
                Nombre: '--Seleccione un estado--'
            })
        },
        async ObtenerLocalidades(estado) {
            this.datosTemp.localidad = '';
            let estadoTemp = this.datosSelect.estados.filter(e => e.Nombre === estado)[0]
            if (estadoTemp) {
                this.datosSelect.localidades = this.localidades.filter(l => l.CveEstado === estadoTemp.Clave || !l.Clave)
            }
            this.$refs.formLocalidad.resetValidation();
        },

        async EditarResidencia() {
            this.localidades = await SistemasService.ObtenerLocalidades(null);

            if (this.detalleUsuario.CveEstado) this.datosSelect.localidades = this.localidades.filter(l => l.CveEstado === this.detalleUsuario.CveEstado || !l.Clave)

            await this.ObtenerEstados();
            this.datosTemp.estado = this.detalleUsuario.Estado;
            this.datosSelect.localidades = this.localidades.filter(l => l.CveEstado === this.detalleUsuario.CveEstado || !l.Clave);
            this.datosTemp.localidad = this.detalleUsuario.Localidad;
            this.puedeEditarLocalidad = true;
        },
        async GuardarLocalidad() {
            if ((!this.datosTemp.estado || this.datosTemp.estado?.trim() !== '--Seleccione un estado--') && !(this.$refs.formLocalidad.validate() === true)) return;
            let localidadTemp = this.datosSelect.localidades.filter(l => l.Nombre === this.datosTemp.localidad)[0]
            let loclave = localidadTemp ? localidadTemp.Clave : null
            this.guardandoLocalidad = true;
            await SistemasService.ActualizarLocalidad(this.detalleUsuario.Uslogin, loclave)
                .then((response) => {
                    if (response) {
                        this.detalleUsuario.Estado = loclave ? this.datosTemp.estado : ' '
                        this.detalleUsuario.Localidad = loclave ? this.datosTemp.localidad : ' '
                        this.datosTemp.estado = ''
                        this.Notifica('success', 'Localidad actualizada', '')
                    } else {
                        this.Notifica('warning', 'Algo salió mal')

                    }
                }).catch((e) => {
                    this.Notifica('warning', 'Algo salió mal', e)
                    this.guardandoLocalidad = false;

                })
            this.ObtenerDetalleUsuario();
            this.puedeEditarLocalidad = false
            this.guardandoLocalidad = false;

        },
        SeleccionarPermiso(params, item, file) {

        },
        async SeleccionarPerfil(val) {
            if (val != null) {


                let perfilTemp = this.datosSelect.perfiles.filter(p => p.pfdesc === val)[0];
                this.LimpiarPerfilForm();
                if (this.detalleUsuario.perfil != perfilTemp.pfclave) {
                    this.showClean = true;
                }
                else {
                    this.opcPermisos = 0;
                    this.showClean = false;
                }

                // Gerente operativo || Supervisor operativo
                if (perfilTemp.pfclave === 3 || perfilTemp.pfclave === 2) {
                    if (!this.datosSelect.gerencias?.length) await this.ObtenerGerencias();
                }


                // Ejecutivo
                this.mostrarAbogados = perfilTemp.pfclave === 4
                // Ejecutivo || Ejecutivo Dictamen
                this.mostratTiposEjecutivo = perfilTemp.pfclave === 5 || perfilTemp.pfclave === 15;
                this.mostrarGerencias = perfilTemp.pfclave === 2 || perfilTemp.pfclave === 3
                this.mostrarSupervisorias = perfilTemp.pfclave === 2
            }

        },
        HandleSelectGerencia(val) {
            this.datosTemp.supervisoria = ''

            let gerenciaTemp = this.datosSelect.gerencias.filter(g => g.Nombre === val)[0]

            this.ObtenerSupervisorias(gerenciaTemp.Clave);

        },
        async GuardarPerfil() {
            let clavesCuentas = [];

            let tipoEjecutivoTemp = this.datosSelect.tiposEjecutivo.filter(e => e.Nombre === this.datosTemp.tipoEjecutivo)[0];

            if (!(this.$refs.formPerfil.validate() === true)) return;
            if (this.mostrarAbogados) {
                if (this.datosTemp.abogado == '') {
                    this.validaProveedor = true;
                    return;
                }
            }
            this.guardandoPerfil = true
            let perfilTemp = this.datosSelect.perfiles.filter(p => p.pfdesc === this.datosTemp.perfil)[0]
            if (perfilTemp.pfclave === 5 || perfilTemp.pfclave === 15) {
                this.datosTemp.cuentasAsignadas.forEach((c) => {
                    let cuentaAux = this.datosSelect.clientes.filter(cl => cl.Nombre === c)[0]
                    if (cuentaAux) clavesCuentas.push(cuentaAux.Clave)
                });
            }

            // Ejecutivo Dictamen
            if (perfilTemp.pfclave === 15 && this.detalleUsuario.CvePuesto !== 65) {
                this.Notifica('warning', `Puesto no compatible`, `El perfil ${this.datosTemp.perfil} sólo se puede asignar a un puesto Ejecutivo de cuenta o Ejecutivo de dictamen,
                 del área Subd.Ctas.Esp.y Contact Center`, false)
                this.guardandoPerfil = false
                return;
            }

            //Operador telefónico
            if (perfilTemp.pfclave === 14 && (this.detalleUsuario.CvePuesto !== 69 && this.detalleUsuario.CvePuesto !== 63 && this.detalleUsuario.CvePuesto !== 30)) {
                this.Notifica('warning', `Puesto no compatible`, `Debe seleccionar alguno de los siguientes puestos: 
                Operador Bilingüe en el área Subd.Ctas.Esp.y Contact Center, 
                Operador Contact Center en el área Subd.Ctas.Esp.y Contact Center, 
                Operador Telefonico en el área Optimización Operativa`, false)
                this.guardandoPerfil = false
                return;
            }

            //Supervisor de cabina
            if (perfilTemp.pfclave === 13 && (this.detalleUsuario.CvePuesto !== 31 && this.detalleUsuario.CvePuesto !== 74)) {
                this.Notifica('warning', `Puesto no compatible`, `Debe seleccionar alguno de los siguientes puestos: 
                Supervisor CAP en el área Optimización Operativa, 
                Coordinador Senior en el área Subd.Ctas.Esp.y Contact Center`, false)
                this.guardandoPerfil = false
                return;
            }

            await SistemasService.ActualizarDatosPerfil(
                MetodosGenerales.ObtenerUserName(),
                this.detalleUsuario.Perfil,         // perfilActual,
                perfilTemp.pfclave,                 // perfilNuevo,
                this.detalleUsuario.PermisoPerfil,  // permisoPerfilActual,
                perfilTemp.pfvalor,                 // permisoPerfilNuevo,
                this.detalleUsuario.Uslogin,        // uslogin, 
                this.getUpValor(false, perfilTemp.pfvalor),             // usvalorActual,
                this.getUpValor(true, perfilTemp.pfvalor),              // usvalorNuevo,
                this.detalleUsuario.Correos,        // correos,
                perfilTemp.pfvalor === 27 ? clavesCuentas : null,     // cuentasNuevas,
                perfilTemp.pfvalor === 27 ? tipoEjecutivoTemp.Clave : null,// tipoEjecutivo,
                this.opcPermisos// accionPermiso
            ).then((response) => {
                if (response) {
                    this.puedeEditarPerfil = false
                    this.mostratTiposEjecutivo = false
                    this.mostrarAbogados = false
                    this.mostrarGerencias = false
                    this.mostrarSupervisorias = false;
                    this.opcPermisos = 0;

                    if (this.detalleUsuario.Perfil != perfilTemp.pfclave) {
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: `Recordatorio`,
                            text: `Se realizará un cambio en el perfil. Por favor, verifica que el puesto, área y jefe sean correctos, o realiza los cambios necesarios. `,
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                        }).then(async () => {
                            this.Notifica('success', 'Perfil actualizado', '')
                        });
                    } else {
                        this.Notifica('success', 'Perfil actualizado', '')
                    }
                } else this.Notifica('warning', 'No fue posible actualizar el perfil', '')
            }).catch((e) => {
                this.guardandoPerfil = false
                this.Notifica('warning', 'Algo salió mal', 'Por favor, notifica al equipo de desarrolladores: ', e)
            })

            await this.ObtenerDetalleUsuario();

            this.ObtenerModulos();
            await this.ObtenerModulosUsuario();
            await this.reloadTableBloqueos();

            await this.reloadTableEditarPermisos(-1, true);
            await this.reloadTableAgregarPermisos();

            this.guardandoPerfil = false;
            this.showClean = false;

        },
        async GuardarPermisos() {
            this.cargandoAgregar = true
            let array = this.permisosParaAgregar?.map(p => p.ClavePermiso)
            let peclaves = array.join(',')

            await SistemasService.GuardarPermisos(this.detalleUsuario.Uslogin, peclaves, MetodosGenerales.ObtenerUserName(), null)
            await this.reloadTableEditarPermisos(-1, true);
            await this.reloadTableAgregarPermisos();
            await this.ObtenerModulosUsuario();
            this.cargandoAgregar = false
            this.permisosParaAgregar = []
            this.Notifica('success', 'Permisos agregados', 'Se han agregado los permisos seleccionados a este usuario')

        },
        async EliminarPermisos() {
            this.cargandoEliminar = true
            let array = this.permisosParaEliminar?.map(p => p.ClavePermiso)
            let peclaves = array.join(',')
            let res = await SistemasService.EliminarPermisos(this.detalleUsuario.Uslogin, peclaves)
            await this.reloadTableEditarPermisos(this.displayInputsEditar.modulo, true);
            this.datosTemp.permiso = '';
            this.datosTemp.modulo.peclave = -1;
            this.datosTemp.modulo.pedesc = 'Todo';


            await this.reloadTableAgregarPermisos();
            this.permisosParaEliminar = []
            // this.modulosUsuario
            await this.ObtenerModulos();
            await this.ObtenerModulosUsuario();


            //if (this.datosTemp.modulo != '' && res) {
            //    this.datosTemp.modulo
            //    let matches = this.datosTemp.modulo.match(/(\d+)/)[0];
            //    let number = Number(matches)
            //    number -= array.length
            //    this.datosTemp.modulo = this.datosTemp.modulo.replace(/(\d+)/, number);


            //}
            await this.ObtenerDetalleUsuario();

            this.cargandoEliminar = false;
            this.Notifica('success', 'Permisos eliminados', 'Los permisos se han elimnado correctamente')

        },
        async DarDeBaja() {
            this.disabledbaja = true;
            let resp = await SistemasService.ValidaUsuariosAsignados(this.detalleUsuario.Uslogin);

            if (resp) {
                this.disabledbaja = false;
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Usuario con Personal a cargo',
                    html: 'El usuario aún tiene personal a cargo, ¿Desea asignar un nuevo jefe?',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    denyButtonColor: '#6e7881',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    denyButtonText: 'Continuar sin Asignar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.datosSelect.nombresJefes = await SistemasService.ObtenerJefes(this.detalleUsuario.Uslogin, this.detalleUsuario.Area, this.detalleUsuario.CvePuesto);


                        this.bajaDialog = true;
                    } else if (result.isDenied) { // Agrega la lógica para el botón de denegar
                        this.continuarSinAsignar();
                    }
                });
            }
            else {
                this.disabledbaja = false;
                this.continuarSinAsignar();
            }








        },
        async continuarSinAsignar() {
            this.overlay = true;
            await SistemasService.DarDeBajaUsuario(this.detalleUsuario.Uslogin).then((res) => {
                if (res) {
                    this.Notifica('success', 'Usuario dado de baja', '')
                    this.ObtenerDetalleUsuario()
                }
            })
                .catch((e) => this.Notifica('warning', 'No fue posible realizar la operación', e))
            this.CancelarBusquedaUsuario();
            this.overlay = false;
        },
        async guardarAsigJefe() {
            if (!(this.$refs.form6.validate() === true)) return;
            this.bajaDialog = false;
            this.overlay = true;
            await SistemasService.AsignarJefe(this.detalleUsuario.Uslogin, this.jefesAsignacion.usid).then((res) => {

                setTimeout(() => {
                    this.overlay = false;
                    if (res) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Exito!',
                            text: 'Personal Asignado a nuevo jefe... Espere un momento',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            timer: false
                        });
                        this.cancelarAsigJefe();
                        setTimeout(() => {
                            this.continuarSinAsignar();
                        }, 2000);
                    }
                }, 2000);



            }).catch((e) => this.Notifica('warning', 'No fue posible realizar la operación', e))

        },
        cancelarAsigJefe() {

            this.jefesAsignacion = '';
            this.$refs.form6.resetValidation();
            this.bajaDialog = false;
        },
        async Reactivar() {
            this.overlay = true
            await SistemasService.ReactivarUsuario(this.detalleUsuario.Uslogin).then((res) => {
                if (res) {
                    this.Notifica('success', 'Usuario reactivado', '')
                    this.ObtenerDetalleUsuario()
                }
                else this.Notifica('warning', 'No fue posible realizar la operación', '')
            })
                .catch((e) => this.Notifica('warning', 'No fue posible realizar la operación', e))
            this.overlay = false

        },
        async GenerarIVR() {
            let uslogin = MetodosGenerales.ObtenerUserName()
            let param = this.detalleUsuario.PermisoPerfil == 23 ? this.detalleUsuario.Prclave + '|' + this.detalleUsuario.Uslogin : this.detalleUsuario.Uslogin
            SistemasService.GenerarIVR(param, this.detalleUsuario.PermisoPerfil, uslogin)
                .then(async (res) => {
                    if (res) {
                        await this.reloadTableEditarPermisos(-1, true);
                        await this.reloadTableAgregarPermisos();
                        this.Notifica('success', 'IVR generado', '')
                        this.detalleUsuario = this.ObtenerDetalleUsuario();
                    }
                    else this.Notifica('warning', 'No fue posible preparar generar IVR', '')
                })
                .catch((e) => this.Notifica('warning', 'Algo salió mal', e))



        },
        async PrepararFirmaElectronica() {
            this.overlay = true

            await SistemasService.PrepararFirmaElectronica(this.detalleUsuario.Uslogin)
                .then((res) => {
                    if (res) this.Notifica('success', 'Firma electrónica preparada', '')
                    else this.Notifica('warning', 'No fue posible preparar firma electrónica', '')
                })
                .catch((e) => this.Notifica('warning', 'Algo salió mal', e))
            this.overlay = false

        },
        async ObtenerPerfiles() {
            this.datosSelect.perfiles = await SistemasService.ObtenerPerfilesAdministracion();
        },
        async ObtenerTiposEjecutivo() {
            this.datosSelect.tiposEjecutivo = await SistemasService.ObtenerTiposEjecutivo();
        },
        async ObtenerGerencias() {
            this.datosSelect.gerencias = await SistemasService.ObtenerGerencias();
        },
        async ObtenerSupervisorias(geclave) {
            this.datosSelect.supervisorias = await SistemasService.ObtenerSupervisorias(geclave);
        },
        async BuscarAbogados(input) {
            if (!input) return;
            if (input?.length < 3) {
                this.datosSelect.abogados = []
                return;
            }
            this.datosSelect.abogados = await SistemasService.ObtenerAbogados(input);
        },
        CancelarEdicionPerfil() {
            this.puedeEditarPerfil = false;
            this.mostratTiposEjecutivo = false
            this.mostrarAbogados = false;
            this.opcPermisos = null
            this.datosTemp.abogado = ''
        },
        getUpValor(nuevo, valorPermisoNuevo) {
            var usvalor = null;
            var permisoPF = nuevo ? valorPermisoNuevo : this.detalleUsuario.PermisoPerfil;
            let gerenciaTemp;
            switch (permisoPF) {
                case 24:
                    if (nuevo) {
                        let supervisoriaTemp = this.datosSelect.supervisorias.filter(s => s.Nombre === this.datosTemp.supervisoria)[0]
                        usvalor = supervisoriaTemp ? supervisoriaTemp.Clave : null;
                    }
                    else
                        usvalor = this.detalleUsuario.Suclave;
                    break;
                case 25:
                    if (nuevo) {
                        gerenciaTemp = this.datosSelect.gerencias.filter(g => g.Nombre === this.datosTemp.gerencia)[0]
                        usvalor = gerenciaTemp.Clave
                    }
                    else
                        usvalor = this.detalleUsuario.Geclave;
                    break;
                case 23:
                    if (nuevo) {
                        let prclave = this.datosTemp.abogado.Nombre.split("|")[0]?.trim();
                        usvalor = prclave
                    }
                    else
                        usvalor = this.detalleUsuario.Prclave;
                    break;
                case 27:
                    if (!nuevo)
                        usvalor = this.detalleUsuario.Ejeclave;
                    break;
                default:
                    usvalor = null;
                    break;
            }
            return usvalor;
        },
        HandleWriteCorreos(txt) {
            var regex = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            const search = this.datosTemp.correos.filter(c => c?.trim() === txt)[0]
            this.datosTemp.correosArr = []

            if (regex.test(txt) && !search) {
                this.datosTemp.correosArr.push(txt);
            }
        },
        async ObtenerFlotillas() {
            this.datosSelect.flotillas = await SistemasService.ObtenerFlotillas(this.datosTemp.claveCliente);
            if (this.datosSelect.flotillas?.length) this.datosSelect.flotillas.unshift({
                Clave: null,
                Nombre: '--Seleccione una flotilla--'
            })
        },
        async ObtenerAgentes(busqueda) {
            if (!busqueda) {
                this.datosSelect.agentes = [];
                return;
            }
            this.datosSelect.agentes = await SistemasService.ObtenerAgentes(this.datosTemp.claveCliente, busqueda);
        },
        SeleccionarTodo(tipo) {
            if (tipo == 1) {
                const rows = this.apDT.rows({ page: 'current' });
                rows.select();
                if (this.permisoCausion == false) {
                    this.apDT.rows('.blocked-row').deselect();
                }
            } else if (tipo == 2) {
                const rows = this.apDT.rows({ page: 'current' });
                rows.deselect();
            } else if (tipo == 3) {
                const rows = this.apDT.rows({ page: 'current' });
                rows.every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
                this.apDT.rows('.blocked-row').deselect();
            }
        },
        AccionesEditarPermisos(tipo) {
            if (tipo == 1) {
                const rows = this.epDT.rows({ page: 'current' });
                rows.select();
                if (this.permisoCausion == false) {
                    this.epDT.rows('.blocked-row').deselect();
                }
            } else if (tipo == 2) {
                const rows = this.epDT.rows({ page: 'current' });
                rows.deselect();
            } else if (tipo == 3) {
                const rows = this.epDT.rows({ page: 'current' });
                rows.every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
                this.epDT.rows('.blocked-row').deselect();
            }
        },
        async ObtenerModulos() {
            this.modulos = await SistemasService.ObtenerModulos(this.detalleUsuario.Uslogin);
        },
        async ObtenerModulosUsuario() {
            this.modulosUsuario = await SistemasService.ObtenerModulosUsuario(this.detalleUsuario.Uslogin)
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        async EnviarCorreoAExterno() {
            this.enviandoCorreo = true
            await SistemasService.EnviarCorreoAExterno(this.detalleUsuario.NombreCompleto,
                this.detalleUsuario.Uslogin,
                this.detalleUsuario.Correos,
                MetodosGenerales.ObtenerUserName())
            this.Notifica('success', 'Correo enviado', 'Correo enviado con los datos de acceso del usuario')
            this.enviandoCorreo = false
        },
        formateoDesbloquear(datos) {
            return `<center>
                            <button type="button" data-action="0" data-params="${datos}" class="mr-1 dt-formatterAction bg-green-600 px-2 py-1 rounded-full" >
                                <span style="color:white;" class='mdi mdi-lock-open'></span>
                            </button>
                        </center>`
        },
        CancelarBusquedaUsuario() {
            this.mostrarBusquedaUsuarios = false;
            this.datosTemp.usuario = ''
        },
        async EliminarFotoPerfil() {
            await ArchivosService.EliminarFotoPerfil(this.detalleUsuario.FotoUsuario,
                this.detalleUsuario.Uslogin,
                MetodosGenerales.ObtenerUserName())
                .then((res) => {
                    this.detalleUsuario.FotoUsuario = null;
                    this.fotoPerfil = null
                })
        },
        addMailValider2() {
            var regex = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            if (!regex.test(this.datosTemp.correo || this.datosTemp.correos.filter(c => c === this.datosTemp.correo))) {
                this.datosTemp.correo = ''
            }

        },
        resetItemsSelector() {
            if (this.datosTemp.correosValor != null) {
                // this.mailSelected++;
                this.datosTemp.correosValor.push(this.datosTemp.correo);
                this.datosTemp.correosValor = null;
                this.correos.items = null;
            }
        },

        validarFecha() {
            if (this.detalleUsuario.FechaAlta && typeof this.detalleUsuario.FechaAlta === "string") {
                const [dia, mes, anio] = this.detalleUsuario.FechaAlta.split("/");
                if (dia && mes && anio) {
                    const fechaISO = `${anio}-${mes}-${dia}`;
                    const fechaBase = new Date(`${fechaISO}T00:00:00`);
                    fechaBase.setDate(fechaBase.getDate() - 15);

                    this.minDateFhIni = fechaBase.toISOString().split("T")[0];
                }
            }
        },
    }

}


</script>
<style>
.tableFilter div.dt-buttons {
    float: right;
}

.tableFilter div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
}

.tableFilter .dataTables_wrapper .dataTables_filter {
    float: left;
    text-align: left;
}
</style>
<style>
.media-text {
    font-size: 18px;
}

@media only screen and (max-width: 420px) {
    .media-text {
        font-size: 10px !important;
    }
}

.flex-container {
    padding: 0;
    margin: 0;
    list-style: none;
    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;
}

.nowrap {
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
}

.wrap {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}

.wrap li {}

.wrap-reverse {
    -webkit-flex-wrap: wrap-reverse;
    flex-wrap: wrap-reverse;
}

.wrap-reverse li {
    background: deepskyblue;
}

.flex-item {
    width: auto;
    color: white;
    font-weight: bold;
    font-size: 2em;
    text-align: center;
}
</style>

<style scoped>
label {
    color: gray;
}

.card-header {
    height: 50px;
}

.messenger-avatar {
    margin: 12px auto;
    position: relative;
    width: 128px
}



.messenger-avatar-btn {
    background-color: rgba(0, 0, 0, .5);
    background-image: none;
    border: none;
    border-radius: 6px 0;
    bottom: 0;
    color: #fff;
    cursor: pointer;
    display: block;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
    margin: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    right: 0;
    text-align: center;
    width: 30px;
    z-index: 5;
}


.messenger-avatar-btn:focus,
.messenger-avatar-btn:hover {
    background-color: #000
}

.card-header {
    border-bottom: 1px solid #eee;
    padding: 10px 15px;
    position: relative;
    background-color: #3b82f6;
    color: white;
}

.circle-container {
    background-color: black;
    width: 150px;
    /* Ancho del círculo */
    height: 150px;
    /* Alto del círculo */
    border-radius: 50%;
    /* Hace que el contenedor sea un círculo */
    /*-overflow: hidden; */
    /* Oculta el contenido que se desborda */
    position: relative;
    /* Permite posicionar la imagen absolutamente dentro del contenedor */
}

.circle-container img {
    width: 100%;
    /* Ajusta el ancho de la imagen al 100% del contenedor */
    height: 100%;
    /* Ajusta la altura de la imagen al 100% del contenedor */
    object-fit: cover;
    /* Ajusta la imagen proporcionalmente al contenedor sin distorsionarla */
    border-radius: 50%;
}

.boton-redondo {
    background-color: #536dfe;
}

.wrap-text {
    -webkit-line-clamp: unset !important;
}

.mdi-calendar {
    color: #536dfe !important;
}

.modulo-btn input[type="radio"] {
    background-color: white;
    color: #536dfe;
    font-size: small;
    border: none;
    padding: 2px;
}

.modulo-btn:hover input[type="radio"] {
    background-color: #536dfe;
    color: white;
    border-radius: 4px;
    padding: 3px;
}

.modulo-btn input[type="radio"]:checked+button {
    background-color: black;
    color: red;
}

.icon {
    border-radius: 50%;
    background-color: #536dfe;
    color: white;
    font-size: small;
    padding: 2px;
}

/* custom radio button */

input[type="radio"] {
    display: none;
    cursor: pointer;
}


.etiqueta {
    position: relative;
    color: #536dfe;
    align-items: center;
    padding: 10px;
    cursor: pointer;
}

.etiqueta2 {
    position: relative;
    background-color: #536dfe;
    color: white;
    align-items: center;
    padding: 2px 6px;
    border-radius: 50px;
    cursor: pointer;
}


input[type="radio"]:checked+.etiqueta {
    background-color: #536dfe !important;
    color: white;
    border-radius: 3px;
}

input[type="radio"]:hover+.etiqueta {
    background-color: #d6d6d656;
}

input[type="radio"]:checked+.etiqueta>.etiqueta2 {
    background-color: white;
    color: #536dfe;
}


/* loader foto */
.loader-foto {
    width: 80px;
    height: 80px;
    display: inline-block;
    position: relative;
    top: 35px;
}

.loader-foto::after,
.loader-foto::before {
    content: '';
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid #FFF;
    position: absolute;
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
}

.loader-foto::after {
    animation-delay: 0s;
}

@keyframes animloader {
    0% {
        transform: scale(0);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 0;
    }
}
</style>

<style lang="scss">
@media screen and (max-width: 700px) {
    .DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.9rem;
    }

    .DatosGenerales .vs-list--subtitle {
        font-size: 1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 700px) and (max-width: 1060px) {
    .DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    .DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1060px) and (max-width: 1364px) {
    .DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    .DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1364px) and (max-width: 2004px) {
    .DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.2rem;
    }

    .DatosGenerales .vs-list--subtitle {
        font-size: 1.3rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 2004px) {
    .DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.3rem;
    }

    .DatosGenerales .vs-list--subtitle {
        font-size: 1.4rem;
        font-weight: 700;
    }



}
</style>